import { defineStore } from 'pinia';
import searchApi from '@/app/features/ams/common/search-service';
import { useAlertStore } from '@/app/shared/stores/alert-store';
import { Motif } from '@/app/shared/enums/motif-enum';

export const useSearchStore = defineStore({
  id: 'userLoginNamesId',
  state: () => ({
    userLoginNamesList: [],
  }),
  // TODO: Getter should return computed or processed values, all this functions
  // return the same value as accessing the state directly
  getters: {
    getUserLoginNamesList(): Array<any> {
      return this.userLoginNamesList;
    },
  },

  actions: {
    async fetchUserLoginNamesList(clientId: number) {
      const alertStore = useAlertStore();
      try {
        const resp = await searchApi.getUserLoginNamesList(clientId);
        this.userLoginNamesList = resp.data.data || [];
      } catch (e) {
        // TODO: Create an interface for this attribute or use an existing one
        const error: any = e;
        alertStore.showNotification(
          error.errors[0].message,
          'Filters',
          Motif.ERROR
        );
      }
    },
  },
});
